export default "__VITE_ASSET__B1MH$Zd2__"